import { Base64 } from 'js-base64';
import {
	GOTIFY_URL,
	// SERVER_HOST_NAME
} from "@/app.conf"


// https://gotify.net/api-docs#/
// Properties
export const MIN_PRIORITY_MESSAGES = 0
export const LOW_PRIORITY_MESSAGES_1 = 1
export const LOW_PRIORITY_MESSAGES_2 = 2
export const LOW_PRIORITY_MESSAGES_3 = 3
export const NORMAL_PRIORITY_MESSAGES_1 = 4
export const NORMAL_PRIORITY_MESSAGES_2 = 5
export const NORMAL_PRIORITY_MESSAGES_3 = 6
export const NORMAL_PRIORITY_MESSAGES_4 = 7
export const HI_PRIORITY_MESSAGES = 8


// Authorization
let _user = undefined
let _password = undefined


// Need init API before use
export function initGotifyApi(user, password) {
	_user = user
	_password = password
}


/* Creates a new Gotify user
Return promise with response.
response.id: user id
*/
export async function createUser(login, pass) {
	return fetch(`${GOTIFY_URL}/user`, {
		method: "POST",
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Basic ' + Base64.encode(_user + ":" + _password),
		},
		body: JSON.stringify({
			admin: false,
			name: login,
			pass: pass,
		}),
	})
	.then((response) => {
		if (response.ok) {
			return response.json()
		} else {
			throw new Error(response)
		}
	})
}


/* Update a user */
export async function updateUser(userId, newName, newPass) {
	return fetch(`${GOTIFY_URL}/user/${userId}`, {
		method: "POST",
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Basic ' + Base64.encode(_user + ":" + _password),
		},
		body: JSON.stringify({
			pass: newPass,
			name: newName,
		}),
	})
	.then((response) => {
		if (response.ok) {
			return response.json()
		} else {
			throw new Error(response)
		}
	})
}


/* Creates the application for gotify user.
Return promise with response.
response.id: application id
response.token: application token
*/
export async function createApplicationForUser(login, pass, name, priority=0, description='') {
	return fetch(`${GOTIFY_URL}/application`, {
		method: "POST",
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Basic ' + Base64.encode(login + ":" + pass),
		},
		body: JSON.stringify({
			defaultPriority: priority,
			description: description,
			name: name
		}),
	})
	.then((response) => {
		if (response.ok) {
			return response.json()
		} else {
			throw new Error(response)
		}
	})
}


/* */
export async function setApplicationIcon(login, pass, appId, imageBlob) {
	// Make data for send to server
	const formData = new FormData();
	formData.append('file', imageBlob, 'icon.jpg');

	return fetch(`${GOTIFY_URL}/application/${appId}/image`, {
		method: "POST",
		headers: {
			'Authorization': 'Basic ' + Base64.encode(login + ":" + pass),
		},
		body: formData, 
	})
}


/* */
export async function deleteUser(userId) {
	const formData = new FormData();
	formData.append('id', userId);

	return fetch(`${GOTIFY_URL}/user/${userId}`, {
		method: "DELETE",
		mode: "cors",
		cache: "no-cache",
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Basic ' + Base64.encode(_user + ":" + _password),
		},
		id: userId,
		//body: formData,
		body: JSON.stringify({
			id: userId
		}),
	})
}


/*
Send messages throuth gotify
*/
export async function sendToGotify(message, token) {
	return fetch(`${GOTIFY_URL}/message`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"X-Gotify-Key": token,
		},
		body: JSON.stringify({
			message: `${message}`,
			priority: 2,
			title: "",
			extras: {
				'client::notification': {
					// click: {
					// 	url: "http://" + SERVER_HOST_NAME + "/alerts"
					// },
					// bigImageUrl: "https://infoindustria.com.ua/wp-content/uploads/2022/02/091105121903_gas_226.jpg"
				},
				// 'android::action': {
				// 	onReceive: { intentUrl: "http://" + SERVER_HOST_NAME + "/alerts" }
				// }
			}
		}),
	})
}